import { Component, Input, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

import { BaseComponent } from '@core/components/base/base.component';
import { FloatingViewComponent } from '@shared/components/floating-view/floating-view.component';

import { CartService } from '@core/services/cart/cart.service';
import { RupeePipe } from '@app/shared/pipes/rupee.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgTemplateOutlet, NgStyle } from '@angular/common';
import { SelectorComponent } from '../dummy-template/selector/selector.component';
import { GtmService } from '@app/core/services/analytics/gtm.service';

@Component({
    selector: 'app-bill-details',
    templateUrl: './bill-details.component.html',
    styleUrls: ['./bill-details.component.scss'],
    standalone: true,
    imports: [SelectorComponent, NgTemplateOutlet, MatExpansionModule, NgStyle, RupeePipe]
})
export class BillDetailsComponent extends BaseComponent implements OnDestroy {

    serverCart: any;
    isCartUpdating = false;
    destroySubject$: Subject<void> = new Subject();

    total_savings = 0;
    bill_details: any;

    @Input() expanded = true;

    constructor(
        private cartService: CartService,
        private dialog: MatDialog,
        private gtmService: GtmService
    ) {
        super();
    }

    ngOnInitBrowser() {
        this.cartService.serverCart
            .pipe(takeUntil(this.destroySubject$))
            .subscribe((data: any) => {
                if (data && Object.keys(data).length && Object.keys(data.items).length) {
                    this.serverCart = data;
                    this.serverCart.bill_details = this.serverCart.bill_details.map(item => {
                        if (item.type === 'Credit' && item.amount_with_credit > 0) {
                            item.gross_total = item.amount = item.amount_with_credit = -1 * item.amount_with_credit;
                        }
                        return item;
                    });
                }
            });
    }

    ngOnDestroy() {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }

    isCreditsUsed(): boolean {
        return this.cartService.isCurrencyUsed;
    }

    getFinalCartPrice(): number {
        return this.cartService.getFinalCartPrice();
    }

    getTotalSavings() {
        return this.serverCart && (this.serverCart.total_saving_amount + this.getCreditsUsed());
    }

    getCreditsUsed() {
        if (this.isCreditsUsed()) {
            const credit = this.serverCart.total_saving.filter(item => item.type === 'Credit');
            return credit.length ? credit[0].amount : 0;
        }
        return 0;
    }

    getBillDetails() {
        if (this.isCreditsUsed()) {
            return this.serverCart && this.serverCart.bill_details;
        } else {
            return this.serverCart && this.serverCart.bill_details.filter(item => item.type !== 'Credit');
        }
    }

    openFloatingView(info, type) {
        if (!info.length) {
            return;
        }
        this.dialog.open(FloatingViewComponent, {
            hasBackdrop: true,
            backdropClass: 'floating-panel-backdrop',
            panelClass: 'floating-panel',
            maxWidth: '400px',
            minWidth: '320px',
            data: {
                info,
                type,
                isCreditsUsed: this.isCreditsUsed()
            }
        });
    }

    onPanelOpen() {
        this.gtmService.logWebAnalyticsEvent("cart_page", "Bills Section Expanded: " + (this.isMobile ? "Mobile" : "Desktop"));
    }
}
